export default __webpack_public_path__ + "static/media/landing-art1.3e825dfd.svg";